<script lang="ts">
  let props = $props()
  let certification: any = props.certification
  let user: any = props.user

  import logo_img from "@images/logo/logo-mark.png"

  function addToProfile(certification) {
    let url = `https://www.linkedin.com/profile/add?startTask=CERTIFICATION_NAME&name=${encodeURIComponent(
      certification.name
    )}&organizationId=6578953&issueYear
=${certification.issue_year}&issueMonth=${
      certification.issue_month
    }&certUrl=${encodeURIComponent(
      "https://leadwithpurpose.com/certifications/" + certification.unique_id
    )}&certId=${certification.unique_id}`

    window.open(
      url,
      "targetWindow",
      `toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=800`
    )
  }

  function getMonthName(monthNumber) {
    const date = new Date()
    date.setMonth(monthNumber - 1)

    return date.toLocaleString("en-US", { month: "long" })
  }
</script>

<li class="bg-white rounded-lg shadow mb-3 border-2 border-gray-100">
  <div class="w-full flex space-x-2 lg:space-x-5 p-2 lg:p-6">
    <div class="flex-shrink-0 px-4 lg:px-0">
      <div class="my-4 flex-shrink-0 mt-0 lg:w-40 pr-4 sm:pr-2">
        <img src={logo_img} class="w-24 h-24" alt="Lead With Purpose" />
      </div>
    </div>
    <div class="mt-3 lg:mt-0 pt-1 text-left flex-grow relative">
      <p class="text-3xl lg:text-4xl font-bold text-gray-800 mb-4">
        {certification.name}
      </p>

      <p class="text-base mb-2 inline-flex">
        Awarded to
        {#if user}
          <span class="mx-1 font-bold">{user.name}</span> ({user.email}) of
        {/if}
        {certification.plan_name}.
        <img
          src={certification.plan_logo}
          class="ml-2 h-6 w-6"
          alt={certification.plan_name}
        />
      </p>
      <p class="text-sm text-gray-700 mb-4">
        Issued {getMonthName(certification.issue_month)}
        {certification.issue_year}
      </p>
      {#if user}
        <button
          type="button"
          onclick={() => addToProfile(certification)}
          class="flex items-center"
          title="LinkedIn Profile"
          style="background-color: rgb(10, 102, 194);"
          ><svg
            class="p-2 h-12 w-12 text-white border-r border-gray-600"
            fill="currentColor"
            viewBox="0 0 448 512"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
            ><path
              d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"
            /></svg
          ><span class="px-4 text-white text-lg font-bold"
            ><span aria-hidden="true"> Add to profile </span></span
          ></button
        >
      {/if}
      <p class="text-lg mt-4">{certification.description}</p>
    </div>
  </div>
</li>
